import horizontalCountdownTimerTemplate from './horizontal-countdown-timer.tpl.html';
import './horizontal-countdown-timer.less';
import { timerHelperModule } from '../../helpers/timer-helper';
import { stopEvent } from '../../utils/event-utils';

// shares the timer status across this session
let timerGloballyHidden = false;

export const horizontalCountdownTimerComponentModule = angular
  .module('Q.components.horizontal-countdown-timer', [timerHelperModule])

  .component('horizontalCountdownTimer', {
    bindings: {
      startedAt: '<',
      timeoutSeconds: '<',
      onExpired: '&',
      expiredMessage: '@',
    },
    controller: 'HorizontalCountdownTimerCtrl',
    template: horizontalCountdownTimerTemplate,
  })

  .controller(
    'HorizontalCountdownTimerCtrl',
    function HorizontalCountdownTimerCtrl($scope, $element, timerHelper) {
      const MAX_WARNING_SEC = 5 * 60; // never warn for more than 5 minutes
      const ctrl = this;
      // runs the countdown render
      let timer;
      // tracks the end of the timer separate from the render timer
      let timeLimitTimer;
      // tracks when to start warning
      let timerTailPercent = 75;
      // if true, then we always show even if the candidate stopped
      let timerRunningOut = false;

      const BLANK_MESSAGE = '——';

      ctrl.$onInit = () => {
        if (ctrl.startedAt && ctrl.timeoutSeconds) {
          createTimerHandler();
        } else {
          clearTimers();
          setExpired(false);
          setTimerEl(BLANK_MESSAGE, 100);
        }

        ctrl.$onChanges = (changes) => {
          if (changes.startedAt || changes.timeoutSeconds) {
            createTimerHandler();
          }
        };
      };

      function _setHidden(state) {
        if (!timerRunningOut) {
          timerGloballyHidden = state;
        }
        $element.toggleClass('timer-running-out', timerRunningOut);
        $element.toggleClass(
          'timer-hidden',
          !timerRunningOut && timerGloballyHidden,
        );
      }

      _setHidden(timerGloballyHidden);

      $element.on('click', (event) => {
        stopEvent(event);
        // toggles if we're allowed
        _setHidden(!timerGloballyHidden);
      });

      function setExpired(expired) {
        $element.toggleClass('expired', expired);
        ctrl.onExpired({ expired });
      }

      function clearTimers() {
        if (timer) timer.stop();
        if (timeLimitTimer) timerHelper.longTimeout.cancel(timeLimitTimer);
        timer = null;
        timeLimitTimer = null;
      }

      function timerEnded() {
        const expired = ctrl.startedAt !== 0;
        setExpired(expired);
        const msg = expired
          ? ctrl.expiredMessage || "Time's Up!"
          : BLANK_MESSAGE;
        setTimerEl(msg, 100);
      }

      function createTimerHandler() {
        const startedAt = ctrl.startedAt;
        const timeoutSec = ctrl.timeoutSeconds;
        if (timeoutSec * 0.25 > MAX_WARNING_SEC) {
          // never set the warning range for more than this
          timerTailPercent =
            (100 * (timeoutSec - MAX_WARNING_SEC)) / timeoutSec;
        } else {
          timerTailPercent = 75;
        }
        clearTimers();
        const timeoutMs = timeoutSec * 1000 - (new Date() - startedAt);
        if (timeoutMs < 1) {
          timerRunningOut = true;
          timerEnded();
        } else {
          timerRunningOut = false;
          setExpired(false);
          timer = timerHelper.runEvery(
            () => {
              const secElapsed = (new Date() - startedAt) / 1000;
              let secRemaining = Math.floor(timeoutSec - secElapsed);
              let remaining = [];
              if (secRemaining > 3600) {
                const h = Math.floor(secRemaining / 3600);
                secRemaining -= h * 3600;
                remaining.push(h + 'h');
              }
              if (remaining.length || secRemaining > 60) {
                const m = Math.floor(secRemaining / 60);
                secRemaining -= m * 60;
                remaining.push(m + 'm');
              }
              remaining.push(secRemaining + 's');
              const percent = (100 * secElapsed) / timeoutSec;
              setTimerEl(remaining.join(' '), percent);
            },
            250,
            false,
          );
          timeLimitTimer = timerHelper.longTimeout(() => {
            clearTimers();
            timerEnded();
          }, timeoutMs);
        }
      }

      function setTimerEl(timerText, percent) {
        const timerBoxEl = $element;
        timerRunningOut = percent > timerTailPercent;
        if (timerRunningOut) {
          _setHidden(false);
        }
        timerBoxEl
          .toggleClass('warning', timerRunningOut)
          .toggleClass('danger', percent > (timerTailPercent * 90) / 75)
          .toggleClass('final-warning', percent > (timerTailPercent * 95) / 75)
          .toggleClass('completed', percent >= 100);

        timerBoxEl.querySelector('.timer-status-text').html(timerText);
        timerBoxEl
          .querySelector('.timer-progress')
          .css({ width: percent + '%' });
      }

      $scope.$on('$destroy', clearTimers);
    },
  );
